import React from 'react';

const NebulaPerformanceFormModal = React.lazy(() => import('../components/FormModal'));
const nebulaPerformanceModalRegistry = {
    personalize_nebulaPerformanceId: NebulaPerformanceFormModal
};
export default nebulaPerformanceModalRegistry;
